<template>
  <div>
    <el-button type="primary" class="not-printable" style="margin: 10px" plain @click="print">Drukuj</el-button>

    <el-table :data="cows" stripe :default-sort="{prop: 'number', order: 'descending'}">
      <el-table-column :label="title">
        <el-table-column type="index" width="50">
        </el-table-column>
        <el-table-column prop="number" label="Numer krowy" sortable :sort-method="sortNumber" width="300px">
        </el-table-column>
        <el-table-column prop="date_sumary" :formatter="formatter" label="Data ostatniej insemincaji" width="300px">
        </el-table-column>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      cows: [],
      title: "Data wydruku: " + new Date().toLocaleDateString()
    };
  },
  mounted: function() {
    console.log("moja krowa?", window.opener.mojakrowa);
    if ("cows" in window.opener) {
      this.cows = window.opener.cows;
    }
  },
  methods: {
    formatter(row, column) {
      console.log("row:", row, "column:", column.label, column.property);
      console.log("wartosc:", row[column.property]);
      var rawDate = row[column.property].insemination;
      return rawDate === "0001-01-01T00:00:00Z"
        ? "-"
        : new Date(rawDate).toLocaleDateString(); //toISOString().slice(0, 10);
    },
    sortNumber(n1, n2) {
      return parseInt(n1.number.slice(-5)) - parseInt(n2.number.slice(-5));
    },
    print() {
      window.print();
    }
  }
};
</script>

<style>
@media print {
  .not-printable {
    display: none;
  }
}
</style>
